var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25ZM10.4375 7.4375C10.4375 7.12684 10.6893 6.875 11 6.875C11.3107 6.875 11.5625 7.12684 11.5625 7.4375V12.3125C11.5625 12.6232 11.3107 12.875 11 12.875C10.6893 12.875 10.4375 12.6232 10.4375 12.3125V7.4375ZM11.5625 14.9375C11.5625 15.2482 11.3107 15.5 11 15.5C10.6893 15.5 10.4375 15.2482 10.4375 14.9375C10.4375 14.6268 10.6893 14.375 11 14.375C11.3107 14.375 11.5625 14.6268 11.5625 14.9375Z",
    fill: "#FCA833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.5C16.7991 0.5 21.5 5.20085 21.5 11C21.5 16.7991 16.7991 21.5 11 21.5C5.20085 21.5 0.5 16.7991 0.5 11C0.5 5.20085 5.20085 0.5 11 0.5ZM11 1.55C5.7815 1.55 1.55 5.7815 1.55 11C1.55 16.2185 5.7815 20.45 11 20.45C16.2185 20.45 20.45 16.2185 20.45 11C20.45 5.7815 16.2185 1.55 11 1.55Z",
    fill: "#555555"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/Fail.e04eadf3.svg";
export { ForwardRef as ReactComponent };